import { EmployeeInCharge } from './employeeInCharge';
import { ChangeRequest } from './changerequest';

export class EICChangeRequestModal {
  authorityChangeRequestId: number;
  authorityChangeRequestStatus: String;
  status: string;
  racfId: string;
}
